<template>
  <el-tabs v-model="activeName"  @tab-click="tabClick">
    <el-tab-pane label="行情同步配置" name="first" v-if="rightsContains('QUOTATION_SYNC_SET')">
      <market-quotations ref="child"></market-quotations>
    </el-tab-pane>
    <el-tab-pane label="中间刷量配置" name="second" v-if="rightsContains('BRUSH_CONFIG_SET')">
      <quotation-brush></quotation-brush>
    </el-tab-pane>
    <el-tab-pane label="新增行情策略" name="third" v-if="rightsContains('QUOTATION_SYNC_SET')">
      <add-quotation></add-quotation>
    </el-tab-pane>
    <el-tab-pane label="虚拟深度配置状态查询" name="fourth" v-if="rightsContains('INVENT_DEPTH_CONFIG')">
      <volume-query />
    </el-tab-pane>
    <el-tab-pane label="虚拟深度配置" name="fifth" v-if="rightsContains('INVENT_DEPTH_CONFIG')">
      <volume-set />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import AddQuotation from "@/entries/Machine/addQuotation";
import MarketQuotations from "@/entries/Machine/MarketQuotations";
import QuotationBrush from "@/entries/Machine/QuotationBrush";
import {mapState, mapActions} from 'vuex';
import {RIGHTS_TYPE} from "@/common/constant";
import VolumeQuery from './volumeQuery';
import VolumeSet from './volumeSet'

export default {
  name: "newIndex",
  components: {AddQuotation, MarketQuotations, QuotationBrush, VolumeQuery, VolumeSet},
  data(){
    return {
      activeName:'first'
    }
  },
  methods:{
    ...mapActions('quotationCache', ['queryConfigurations', 'queryBrushConfigurations']),
    rightsContains(r) {
      let rights = this.userRights.split(",") || [];
      return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
    },
    tabClick(tab) {
      if (tab.name !== 'first') {
        this.$refs.child && this.$refs.child.clearTimer()
      } else {
        const syncChild = this.$refs.child
        if (syncChild.pair && this.configurations.findIndex(item => item.pair === syncChild.pair) !== -1) {
          syncChild.getIndexPrice()
          syncChild.setTimer()
        }
      }
      if (tab.name === 'fourth' || tab.name === 'fifth') {
        this.$store.commit('setActivePair', {})
        const child = tab.$children[0]
        child.pair = ''
        child.getList()
      }
    }
  },
  computed: {
    ...mapState(["userInfo", "userRights"]),
    ...mapState('quotationCache', ['configurations'])
  },
  created() {
    if (this.rightsContains('QUOTATION_SYNC_SET')) {
      this.queryConfigurations()
    }
    if (this.rightsContains('BRUSH_CONFIG_SET')) {
      this.queryBrushConfigurations()
    }
  }
}
</script>

<style scoped>

</style>